module.exports = __webpack_public_path__ + "img/3-cartoon.f0c88856.jpg";